<!-- 教练小红花排行 -->
<template>
  <div class="rank-list">
    <FirstRank
      :data="firstRankList"
      :showFocus="showFocus"
      :isMember="isMember"
    ></FirstRank>
    <div
      class="rank-item"
      @click="bindInto(item)"
      v-for="(item, index) in coachRankList"
      :key="index"
    >
      <div class="rank-item-index">{{ index + 4 }}</div>
      <div class="rank-item-avatar">
        <img class="avatar" :src="item.coach_image" alt="" />
        <span class="main-text" v-if="item.is_head_coach">主教练</span>
      </div>
      <div class="rank-item-info">
        <div class="item-name"
          ><div class="true-name">{{ item.coach_name }}</div>
        </div>
        <div class="item-flower" v-if="isMember"
          >已送给Ta
          <span :class="{ 'you-send-num': item.gift_num }"
            >{{ item.gift_num || 0 }}朵</span
          ></div
        >
        <div v-else class="item-store-name">{{ item.store_name }}</div>
      </div>
      <div class="rank-item-total">
        <img
          class="flower-image"
          src="https://btw-common-data.betterwestar.com/btw-admin/resource/71ba3142596f4cf6b18e50e08fa3ca17_wh=66_66.png"
          alt=""
        />
        <div>{{ item.vote_num }}</div>
      </div>
      <div class="rank-item-focus" v-if="showFocus && !item.is_me">
        <div
          v-if="!item.is_follow"
          class="not-focus-btn"
          @click.stop="bindFocus(item)"
        >
          <img
            class="iconfont"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/7d34203215ba29db4a57afc20b678b66_wh=27_27.png"
            alt=""
          />
          <span>关注</span>
        </div>
        <div v-else class="is-focus-btn">已关注</div>
      </div>
    </div>
    <div class="empty" v-if="data && !data.length">
      <img
        class="empty-image"
        src="https://btw-common-data.betterwestar.com/btw-admin/resource/c6909e87377d090f266d8b1e7f1852c5_wh=642_339.png"
        alt=""
      />
      <div class="empty-text">暂无排名</div>
    </div>
  </div>
</template>

<script>
import FirstRank from './first-rank.vue'
export default {
  components: { FirstRank },
  props: {
    data: {
      type: [Array, null],
      default: null
    },
    isMember: {
      type: Boolean,
      default: true
    },
    showFocus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    firstRankList() {
      let list = this.data || []
      list = (list && list.slice(0, 3)) || []
      return list
    },
    coachRankList() {
      let list = this.data || []
      return (list && list.slice(3)) || []
    }
  },
  created() {},
  methods: {
    bindInto(item) {
      let id = item.coach_id
      if (id) {
        this.$betterwe.jumpRoute('/userDetailsPage?id=' + id)
      }
    },
    async bindFocus(item) {
      let params = {
        unify_id: item.coach_id,
        flag: 1
      }
      let res = await this.$http
        .postBaseApp('member/appCamp/optionFollow', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('关注成功')
          item.is_follow = 1
          //this.$store.commit('coachActivity2024/setCoachFocusByUid', item.coach_id);
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.coach-rank {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .find-more {
    padding: 30px 20px 0px;
    font-weight: bold;
    font-size: 14px;
    color: #050b27;
    line-height: 20px;
    margin-bottom: 7px;
    display: flex;
    align-items: center;
    .iconfont {
      font-weight: normal;
      color: rgba(5, 11, 39, 0.3);
      margin-right: 3px;
    }
    .line {
      width: 1px;
      height: 11px;
      background-color: rgba(5, 11, 39, 0.5);
      margin: 0px 5px;
    }
    .change-store {
      font-weight: normal;
      font-size: 12px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 17px;
    }
  }
  .rank-flex {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    .rank-scroll {
      height: 100%;
      overflow-y: scroll;
      .rank-list {
        padding: 10px 20px 32px;

        .rank-item {
          box-sizing: border-box;
          /*  background: linear-gradient(135deg, #f51f6d 0%, #ff79aa 100%);
          border-radius: 4px; */
          padding: 0px 16px 0px 8px;
          display: flex;
          align-items: center;
          margin-bottom: 30px;
          .rank-item-index {
            width: 20px;
            white-space: nowrap;
            margin-right: 3px;
            font-weight: bold;
            font-size: 16px;
            color: rgba(48, 48, 56, 0.5);
            line-height: 22px;
          }
          .rank-item-avatar {
            width: 44px;
            height: 44px;
            position: relative;
            margin-right: 10px;
            .first-flag {
              position: absolute;
              width: 74px;
              height: 74px;
              left: 45%;
              top: 43%;
              transform: translate(-50%, -50%);
            }
            .avatar {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
              overflow: hidden;
            }
            .main-text {
              white-space: nowrap;
              position: absolute;
              z-index: 1;
              left: 50%;
              bottom: 0;
              transform: translate(-50%, 0%);
              height: 15px;
              background: #f64372;
              border-radius: 8px;
              font-weight: bold;
              font-size: 10px;
              color: #ffffff;
              line-height: 15px;
              padding: 0px 10px;
            }
          }
          .rank-item-info {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            margin-right: 10px;
            .item-name {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              display: flex;
              align-items: center;
              margin-bottom: 6px;
              font-weight: bold;
              font-size: 16px;
              color: #050b27;
              line-height: 22px;
              .true-name {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 110px;
              }
            }
            .item-flower {
              font-size: 12px;
              color: rgba(5, 11, 39, 0.5);
              line-height: 16px;
              .you-send-num {
                color: rgba(255, 34, 112, 1);
              }
            }
            .item-store-name {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 12px;
              color: rgba(5, 11, 39, 0.5);
              line-height: 16px;
            }
          }
          .rank-item-total {
            margin-right: 11px;
            display: flex;
            align-items: center;
            font-family: DIN;
            font-weight: bold;
            font-size: 20px;
            color: #ff2270;
            line-height: 26px;
            .flower-image {
              width: 15px;
              height: 15px;
              margin-right: 4px;
            }
          }
          .rank-item-focus {
            .not-focus-btn {
              width: 72px;
              height: 28px;
              box-sizing: border-box;
              background: #ffffff;
              border-radius: 14px;
              border: 0.5px solid rgba(5, 11, 39, 0.2);
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 12px;
              color: #050b27;
              .iconfont {
                width: 9px;
                height: 9px;
                object-fit: contain;
                margin-right: 6px;
              }
            }
            .is-focus-btn {
              width: 72px;
              height: 28px;
              box-sizing: border-box;
              background: #f7f7f7;
              border-radius: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: normal;
              font-size: 12px;
              color: rgba(5, 11, 39, 0.3);
              line-height: 28px;
            }
          }
        }
        .rank-item:last-child {
          margin-bottom: 0px;
        }
        .rank-item-2,
        .rank-item-3 {
          .rank-item-index {
            font-weight: bold;
            color: rgba(220, 0, 80, 1);
          }
        }
        .rank-item-1 {
          width: 96px;
          padding: 19px 16px 19px 8px;
          background: linear-gradient(135deg, #f51f6d 0%, #ff79aa 100%);
          border-radius: 4px;
          .rank-item-index {
            font-weight: bold;
            font-size: 20px;
            color: #fff;
          }
          .true-name {
            color: #fff;
          }
        }
      }
    }
  }
  .empty {
    width: 100%;
    height: 272px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .empty-image {
      width: 214px;
      height: 112px;
      object-fit: contain;
      margin-bottom: 25px;
    }
    .empty-text {
      font-weight: bold;
      font-size: 16px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 22px;
    }
  }
}
</style>
